import { matchPath } from 'react-router';

import getConfigMenu from '../config/menu';

import { CabinetConfig, MenuItem, SettingsMenuItem } from '../types/menu';

export const getMenuItems = (
  config: CabinetConfig,
  displaySize: string,
  modules: string[],
  exclude: string[],
  pathname: string,
  level: number,
  menu: SettingsMenuItem[]
): MenuItem[] => {
  const filter = (item: MenuItem) =>
    item.visible !== false &&
    (!item.module ||
      (modules.includes(item.module) && !exclude.includes(item.module))) &&
    (!item.modules ||
      item.modules.filter((m) => modules.includes(m) && !exclude.includes(m))
        .length === item.modules.length);

  const configMenu = getConfigMenu(config, displaySize);

  const menuItems: MenuItem[] = [];

  menu.forEach((item: SettingsMenuItem) => {
    if (!item.hidden) {
      const menuItem: MenuItem = {
        ...configMenu[item.name],
      };
      if (item?.children) {
        const menuItemItems: MenuItem[] = [];
        item.children.forEach((childrenItem) => {
          if (!childrenItem.hidden) {
            const childItem = configMenu[item.name]?.items?.[childrenItem.name];
            if (childItem) {
              menuItemItems.push(childItem);
            }
          }
        });
        menuItem.items = menuItemItems;
      }
      menuItems.push(menuItem);
    }
  });

  const updatedMenuItems = menuItems.filter(filter).map((it) => {
    const { items, ...item } = it;
    const subItems = items
      ? items
          .map((subItem) => ({
            ...subItem,
            isActive: !!matchPath(
              { path: subItem?.activePath || subItem?.url || '', end: false },
              pathname
            ),
          }))
          .filter(filter)
      : undefined;

    return {
      ...item,
      url: subItems && subItems.length > 0 ? subItems[0].url : item.url,
      isActive: !!matchPath(
        { path: item.activePath || item.url || '', end: false },
        pathname
      ),
      items: subItems,
    };
  });

  if (level === 0) {
    return updatedMenuItems.map(({ items: _items, ...item }) => item);
  }

  if (level > 0) {
    return (
      updatedMenuItems.find(
        (item) =>
          item.items &&
          matchPath(
            {
              path: item.activePath || item.url,
              end: false,
            },
            pathname
          )
      )?.items || []
    );
  }

  return updatedMenuItems;
};

export const getMenuCurrent = (
  config: CabinetConfig,
  displaySize: string,
  modules: string[],
  exclude: string[],
  pathname: string,
  level: number,
  menu: SettingsMenuItem[]
): MenuItem | undefined => {
  return getMenuItems(
    config,
    displaySize,
    modules,
    exclude,
    pathname,
    level,
    menu
  ).find((item) => item.isActive);
};
